// eslint-disable-next-line import/no-extraneous-dependencies
import cryptoES from 'crypto-es';

export const hash = (message: string): string => cryptoES.SHA1(message).toString();
